import PropTypes from 'prop-types'
import { Provider } from 'react-redux'
import { LocalizeProvider } from 'react-localize-redux'
import { applyRouterMiddleware, Router } from 'react-router'
import { HelmetProvider } from 'react-helmet-async'
import { StyledEngineProvider, ThemeProvider, createTheme } from '@mui/material/styles'
import createRoutes from 'modules/router'

// MUI v5's CssBaseline applies the body1 (16px) typography to <body>, whereas
// v4 applied body2 (14px). Restore the smaller v4 baseline so text isn't larger
// than before the upgrade. (createTheme() is otherwise the default theme.)
const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontSize: '0.875rem',
          lineHeight: 1.43,
          letterSpacing: '0.01071em'
        }
      }
    }
  }
})

// injectFirst makes MUI (emotion) inject its styles before our SCSS modules,
// so app styles keep winning the cascade as they did under Material-UI v4 (JSS).
const Root = ({ store, history }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <Provider store={store}>
          <LocalizeProvider store={store}>
            <Router
              render={applyRouterMiddleware()}
              history={history}
              routes={createRoutes(store)}
            />
          </LocalizeProvider>
        </Provider>
      </HelmetProvider>
    </ThemeProvider>
  </StyledEngineProvider>
)

Root.propTypes = {
  history: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired
}

export default Root
